export const partnerExcelConfig = {
  fileName: 'Partners',
  sheetName: 'Partners',
  columns: [
    { header: 'First Name', key: 'firstName' },
    { header: 'Last Name', key: 'lastName' },
    { header: 'Email', key: 'email' },
    { header: 'address', key: "address" },
    { header: 'Designation', key: 'designation' },
    { header: 'Id ProofType', key: 'idProofType' },
    { header: 'Id ProofNumber', key: 'idProofNumber' },
    { header: 'Current Work Location', key: 'currentWorkLocation' },
    { header: 'MaritalStatus', key: 'maritalStatus' },
    { header: 'TotalExperience', key: 'totalExperience' },
    { header: 'Age', key: 'age' },
    { header: 'Gender', key: 'gender' },
    { header: 'Role', key: 'role' },
    { header: 'Phone', key: 'phone' },
    { header: 'Status', key: 'status' },
  ],
};
